import React from "react";
import { motion } from "framer-motion";
import { BRAND } from "@/lib/brand";

const sections = [
  { h: "Information We Collect", p: "We may collect your name, phone number, email address, location, patient care requirement, and basic health-related information that you voluntarily share through phone, WhatsApp, email, or website forms." },
  { h: "How We Use Your Information", p: "We use your information to understand your service requirement, respond to your enquiry, arrange home healthcare services, provide support, confirm appointments, and share service-related communication." },
  { h: "Health Information", p: "Any medical or patient-related information shared with Velixa Health is used only for service coordination and care planning. We do not sell or misuse patient information." },
  { h: "Sharing of Information", p: "We may share necessary details only with relevant healthcare professionals or service staff for fulfilling your requested service. We do not sell your personal data to third parties." },
  { h: "WhatsApp and Calls", p: "By contacting us through phone, WhatsApp, email, or website forms, you agree that Velixa Health may contact you regarding your enquiry or service request." },
  { h: "Data Security", p: "We take reasonable steps to protect your personal information. However, no digital communication method is completely secure, and users should avoid sharing unnecessary sensitive information online." },
  { h: "Emergency Disclaimer", p: "Velixa Health is not an emergency medical service. In case of serious symptoms, medical emergency, breathing difficulty, severe bleeding, chest pain, stroke symptoms, or critical illness, please contact the nearest hospital or emergency ambulance service immediately." },
  { h: "Policy Updates", p: "We may update this Privacy Policy from time to time. Any changes will be posted on this page." },
];

export default function PrivacyPage() {
  return (
    <main data-testid="privacy-page" className="pt-40 md:pt-48 pb-32">
      <section className="mx-auto max-w-[1000px] px-6 md:px-10">
        <p className="text-[11px] uppercase tracking-[0.32em] text-ink/50">Volume V — Legal</p>
        <motion.h1 initial={{ opacity: 0, y: 40 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 1 }} className="mt-4 font-serif text-5xl md:text-7xl leading-[0.98] tracking-tightest text-ink">
          Privacy Policy
        </motion.h1>
        <p className="mt-8 text-[17px] text-ink/70 max-w-3xl leading-relaxed">
          Velixa Health respects your privacy and is committed to protecting the personal information you share with us.
        </p>

        <div className="mt-16 divide-y divide-ink/10 border-y border-ink/10">
          {sections.map((s, i) => (
            <motion.div
              key={s.h}
              data-testid={`priv-${i}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.7, delay: i * 0.04 }}
              className="grid grid-cols-12 gap-6 md:gap-10 py-8 md:py-10"
            >
              <div className="col-span-12 md:col-span-4">
                <div className="chapter-num text-3xl md:text-4xl">{String(i + 1).padStart(2, "0")}</div>
                <h2 className="font-serif text-2xl md:text-3xl text-ink mt-2 tracking-editorial">{s.h}</h2>
              </div>
              <p className="col-span-12 md:col-span-8 text-[15px] md:text-[16px] text-ink/75 leading-relaxed">{s.p}</p>
            </motion.div>
          ))}
        </div>

        <div className="mt-16 border border-ink/15 p-6 md:p-10">
          <div className="text-[11px] uppercase tracking-[0.28em] text-ink/55">For privacy-related questions, contact</div>
          <div className="mt-3 font-serif text-3xl text-ink">Velixa Health</div>
          <div className="mt-2 text-ink/70">Phone · <a href={`tel:+91${BRAND.phone}`} className="link-editorial">{BRAND.phoneDisplay}</a></div>
          <div className="text-ink/70">Email · <a href={`mailto:${BRAND.email}`} className="link-editorial">{BRAND.email}</a></div>
        </div>
      </section>
    </main>
  );
}
